(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosh-hashanah-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ag-countdown')) return;

    class AgCountdown extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.deadline = Date.parse(this.dataset.deadline || '');
        this.expiredAction = this.dataset.expiredAction || 'message';
        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.timer = this.querySelector('.ag-countdown__timer');
        this.expiredMessage = this.querySelector('[data-expired-message]');
        this.onVisibilityChange = () => {
          if (document.hidden) this.stopTimer();
          else this.tick();
        };

        if (!Number.isFinite(this.deadline) || !this.days || !this.hours || !this.minutes || !this.seconds) {
          if (window.Shopify && Shopify.designMode && this.expiredMessage) {
            this.timer.hidden = true;
            this.expiredMessage.textContent = 'Check the deadline format in this section’s settings.';
            this.expiredMessage.hidden = false;
          }
          return;
        }

        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.tick();
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        this.stopTimer();
        if (this.onVisibilityChange) {
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        }
      }

      stopTimer() {
        if (this.timeout) window.clearTimeout(this.timeout);
        this.timeout = null;
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }

      write(element, value) {
        if (element.textContent !== value) element.textContent = value;
      }

      tick() {
        this.stopTimer();
        const remaining = this.deadline - Date.now();

        if (remaining <= 0) {
          this.write(this.days, '00');
          this.write(this.hours, '00');
          this.write(this.minutes, '00');
          this.write(this.seconds, '00');
          this.handleExpiry();
          return;
        }

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        this.write(this.days, this.pad(days));
        this.write(this.hours, this.pad(hours));
        this.write(this.minutes, this.pad(minutes));
        this.write(this.seconds, this.pad(seconds));

        this.timeout = window.setTimeout(() => this.tick(), 1000 - (Date.now() % 1000));
      }

      handleExpiry() {
        if (this.expiredAction === 'hide') {
          this.hidden = true;
          return;
        }

        if (this.expiredAction === 'message' && this.timer && this.expiredMessage) {
          this.timer.hidden = true;
          this.expiredMessage.hidden = false;
        }
      }
    }

    customElements.define('ag-countdown', AgCountdown);
  })();

  } catch(e) { console.error(e); }
})();
})();
